import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { extractErrorMessage, useStore } from "../../../helpers";
import { TARS_FACETS_DELETE_PATH } from "../tars-constants";
import { markTarsNotebookActivity } from "./tars-notebook-last-touched";

export interface DeleteFacetPayload {
  facet_id: number;
  notebook_id?: number;
}

export const useDeleteFacet = () => {
  const rootStore = useStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: DeleteFacetPayload): Promise<void> => {
      await rootStore.apiRequestHandler(
        TARS_FACETS_DELETE_PATH,
        payload,
        "Failed to delete facet"
      );
    },
    onSuccess: (_data, variables) => {
      toast.success("Facet deleted successfully");
      queryClient.invalidateQueries({ queryKey: ["tars", "facets", "list"] });
      markTarsNotebookActivity(queryClient, variables.notebook_id);
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to delete facet"));
    },
  });
};
